import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { UserModel } from '@/api/models/user';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_UpdatePassword_User = UserModel;

export type ApiRequest_UpdatePassword_User = {
  password: string;
};

const METHOD = 'PUT';
const ENDPOINT = 'user/password';

export const useUpdatePassword = (stateFns?: MutationStateFns<ApiResponse_UpdatePassword_User>) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_UpdatePassword_User) =>
      handleApiCall<ApiResponse_UpdatePassword_User, ApiRequest_UpdatePassword_User>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        data
      ),
    onSuccess: data => {
      enqueueSnackbar('Password updated successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to update password', { variant: 'error' });

      // eslint-disable-next-line no-console
      console.error(err);
      stateFns?.onError?.(err);
    },
  });
};
